const denimSizes = ["23", "24", "25", "26", "27", "28", "29", "30", "31", "32"];
const alphaSizes = ["XS", "S", "M", "L", "XL"];

const productData = [
  {
    id: 1,
    name: "LARK FLARE JEAN — ARCHIVE BLUE",
    category: "Denim Pants",
    department: "Woman",
    collection: "FOUNDATIONS 01 · WOMAN",
    price: 248,
    image: "/img/safe-product-01.jpg",
    images: ["/img/safe-product-01.jpg"],
    size: denimSizes,
    colors: ["Archive Blue"],
    material: "100% organic cotton denim",
    description: "A high-rise jean with an elongated flare, cut in structured denim with a softly worn blue finish.",
    attributes: { fit: "High rise / flare", pockets: "Five pockets", origin: "Made in Italy" },
    tags: ["woman", "denim", "foundation", "organic cotton"],
    Features: ["Rigid organic denim", "Five-pocket construction", "Zip fly and metal button", "Wash at 30°C inside out"],
    featured: true,
    stock: 6,
  },
  {
    id: 2,
    name: "VALE ZIP STRAIGHT JEAN — COAL WASH",
    category: "Denim Pants",
    department: "Woman",
    collection: "FOUNDATIONS 01 · WOMAN",
    price: 286,
    image: "/img/safe-product-02.jpg",
    images: ["/img/safe-product-02.jpg"],
    size: denimSizes,
    colors: ["Coal Wash"],
    material: "98% cotton, 2% recycled elastane",
    description: "Relaxed straight denim in a charcoal wash, detailed with a discreet functional zip at each ankle.",
    attributes: { fit: "Mid rise / straight", pockets: "Five pockets", origin: "Made in Italy" },
    tags: ["woman", "denim", "black", "zip detail"],
    Features: ["Soft washed handle", "Functional ankle zips", "Relaxed straight leg", "Low-impact finishing"],
    featured: true,
    stock: 4,
  },
  {
    id: 3,
    name: "HALO WIDE FLARE JEAN — MINERAL BLUE",
    category: "Denim Pants",
    department: "Woman",
    collection: "FOUNDATIONS 01 · WOMAN",
    price: 318,
    image: "/img/safe-product-03.jpg",
    images: ["/img/safe-product-03.jpg"],
    size: denimSizes,
    colors: ["Mineral Blue"],
    material: "80% organic cotton, 20% recycled cotton",
    description: "Sculpted high-rise jeans with a sweeping flare and a layered mineral-blue wash.",
    attributes: { fit: "High rise / wide flare", pockets: "Five pockets", origin: "Made in Italy" },
    tags: ["woman", "denim", "statement wash", "recycled cotton"],
    Features: ["Circular cotton blend", "Hand-finished wash variation", "Full-length leg", "Leather-free back patch"],
    featured: false,
    stock: 8,
  },
  {
    id: 4,
    name: "COVE BARREL JEAN — MIST BLUE",
    category: "Denim Pants",
    department: "Woman",
    collection: "FOUNDATIONS 01 · WOMAN",
    price: 276,
    image: "/img/safe-product-04.jpg",
    images: ["/img/safe-product-04.jpg"],
    size: denimSizes,
    colors: ["Mist Blue"],
    material: "100% organic cotton denim",
    description: "A low-rise barrel jean shaped with curved side seams and finished in pale mist blue.",
    attributes: { fit: "Low rise / barrel", pockets: "Five pockets", origin: "Made in Italy" },
    tags: ["woman", "denim", "barrel leg", "mist blue"],
    Features: ["Curved side seam", "Low-slung waist", "Rigid organic denim", "Tonal tobacco stitching"],
    featured: false,
    stock: 3,
  },
  {
    id: 5,
    name: "ELOWEN WIDE-LEG JEAN — SKY FADE",
    category: "Denim Pants",
    department: "Woman",
    collection: "FOUNDATIONS 01 · WOMAN",
    price: 304,
    image: "/img/safe-product-05.jpg",
    images: ["/img/safe-product-05.jpg"],
    size: denimSizes,
    colors: ["Sky Fade"],
    material: "100% cotton denim",
    description: "An elongated wide-leg silhouette with a precise mid rise and an airy faded-blue tone.",
    attributes: { fit: "Mid rise / wide leg", pockets: "Five pockets", origin: "Made in Italy" },
    tags: ["woman", "denim", "wide leg", "essential"],
    Features: ["Long fluid proportion", "Clean hem", "Garment-washed finish", "Classic five pockets"],
    featured: false,
    stock: 7,
  },
  {
    id: 6,
    name: "NOCTURNE ZIP LEATHER TROUSER — BLACK",
    category: "Leather",
    department: "Woman",
    collection: "FOUNDATIONS 01 · WOMAN",
    price: 458,
    image: "/img/safe-product-06.jpg",
    images: ["/img/safe-product-06.jpg"],
    size: alphaSizes,
    colors: ["Black"],
    material: "Responsibly sourced lamb leather",
    description: "Supple black leather trousers with a relaxed straight cut and restrained ankle hardware.",
    attributes: { fit: "Mid rise / straight", lining: "Viscose twill", origin: "Made in Italy" },
    tags: ["woman", "leather", "black", "tailoring"],
    Features: ["Soft lamb leather", "Ankle zip opening", "Partially lined", "Professional leather clean only"],
    featured: true,
    stock: 2,
  },
  {
    id: 7,
    name: "SIENNA FLARE LEATHER TROUSER — CARAMEL",
    category: "Leather",
    department: "Woman",
    collection: "FOUNDATIONS 01 · WOMAN",
    price: 442,
    image: "/img/safe-product-07.jpg",
    images: ["/img/safe-product-07.jpg"],
    size: alphaSizes,
    colors: ["Caramel"],
    material: "Silky nappa leather",
    description: "Fluid nappa trousers in warm caramel, balancing a clean tailored waist with an easy flare.",
    attributes: { fit: "High rise / flare", lining: "Cupro blend", origin: "Made in Italy" },
    tags: ["woman", "leather", "brown", "flare"],
    Features: ["Lightweight nappa", "Pressed front crease", "Concealed fastening", "Specialist clean only"],
    featured: false,
    stock: 4,
  },
  {
    id: 8,
    name: "ROWEN UTILITY DENIM JUMPSUIT — CHARCOAL",
    category: "Dresses / Jumpsuit",
    department: "Woman",
    collection: "FOUNDATIONS 01 · WOMAN",
    price: 368,
    image: "/img/safe-product-08.jpg",
    images: ["/img/safe-product-08.jpg"],
    size: alphaSizes,
    colors: ["Charcoal"],
    material: "100% cotton denim",
    description: "A charcoal denim jumpsuit with a defined belted waist, practical pockets and a generous leg.",
    attributes: { fit: "Relaxed / belted", pockets: "Six pockets", origin: "Made in Italy" },
    tags: ["woman", "jumpsuit", "denim", "vintage black"],
    Features: ["Removable self belt", "Concealed front zip", "Workwear pockets", "Garment-dyed finish"],
    featured: true,
    stock: 3,
  },
  {
    id: 9,
    name: "SOLACE LEATHER OVERSHIRT — COGNAC",
    category: "Tops / Jackets",
    department: "Woman",
    collection: "FOUNDATIONS 01 · WOMAN",
    price: 486,
    image: "/img/safe-product-09.jpg",
    images: ["/img/safe-product-09.jpg"],
    size: alphaSizes,
    colors: ["Cognac"],
    material: "Silky nappa leather",
    description: "An oversized cognac leather layer with soft shoulders, a curved hem and pared-back utility pockets.",
    attributes: { fit: "Oversized", closure: "Press studs", origin: "Made in Italy" },
    tags: ["woman", "shirt", "leather", "layering"],
    Features: ["Featherweight nappa", "Dropped shoulders", "Curved shirt hem", "Specialist clean only"],
    featured: false,
    stock: 2,
  },
  {
    id: 10,
    name: "MERIDIAN STRAIGHT JEAN — HERITAGE BLUE",
    category: "Denim Pants",
    department: "Woman",
    collection: "FOUNDATIONS 01 · WOMAN",
    price: 252,
    image: "/img/safe-product-10.jpg",
    images: ["/img/safe-product-10.jpg"],
    size: denimSizes,
    colors: ["Heritage Blue"],
    material: "100% organic cotton denim",
    description: "A balanced straight jean with a regular rise and an understated heritage-blue wash.",
    attributes: { fit: "Mid rise / straight", pockets: "Five pockets", origin: "Made in Italy" },
    tags: ["woman", "denim", "classic", "heritage blue"],
    Features: ["12.5 oz denim", "Straight full-length leg", "Antique metal trims", "Plastic-free brand patch"],
    featured: false,
    stock: 10,
  },
  {
    id: 11,
    name: "ROSETTE LOOSE JEAN — PLUM CHARCOAL",
    category: "Denim Pants",
    department: "Woman",
    collection: "FOUNDATIONS 01 · WOMAN",
    price: 294,
    image: "/img/safe-product-11.jpg",
    images: ["/img/safe-product-11.jpg"],
    size: denimSizes,
    colors: ["Plum Charcoal"],
    material: "100% cotton denim",
    description: "Loose low-rise denim in charcoal with a quiet plum undertone and broken-in handle.",
    attributes: { fit: "Low rise / loose", pockets: "Five pockets", origin: "Made in Italy" },
    tags: ["woman", "denim", "washed black", "loose fit"],
    Features: ["Low-impact pigment wash", "Loose leg", "Soft broken-in handle", "Contrast inner binding"],
    featured: false,
    stock: 5,
  },
  {
    id: 12,
    name: "COLUMN DENIM SKIRT — CHARCOAL",
    category: "Denim Pants",
    department: "Woman",
    collection: "FOUNDATIONS 01 · WOMAN",
    price: 264,
    image: "/img/safe-product-12.jpg",
    images: ["/img/safe-product-12.jpg"],
    size: alphaSizes,
    colors: ["Charcoal"],
    material: "100% cotton denim",
    description: "A long charcoal denim skirt with a clean column line and practical front walking split.",
    attributes: { fit: "High rise / column", length: "Maxi", origin: "Made in Italy" },
    tags: ["woman", "skirt", "denim", "black"],
    Features: ["Front walking split", "Five-pocket styling", "Washed black finish", "Reinforced hem"],
    featured: false,
    stock: 6,
  },
  {
    id: 13,
    name: "ARC PANELLED LEATHER SKIRT — BLACK",
    category: "Leather",
    department: "Woman",
    collection: "FOUNDATIONS 01 · WOMAN",
    price: 424,
    image: "/img/safe-product-13.jpg",
    images: ["/img/safe-product-13.jpg"],
    size: alphaSizes,
    colors: ["Black"],
    material: "Silky nappa leather",
    description: "A fluid black leather midi skirt defined by curved panel seams and a restrained sheen.",
    attributes: { fit: "High rise / A-line", length: "Midi", origin: "Made in Italy" },
    tags: ["woman", "skirt", "leather", "black"],
    Features: ["Supple paneled nappa", "Concealed side zip", "Lightweight lining", "Specialist clean only"],
    featured: false,
    stock: 2,
  },
  {
    id: 14,
    name: "FRAME LEATHER MINI DRESS — BLACK",
    category: "Dresses / Jumpsuit",
    department: "Woman",
    collection: "FOUNDATIONS 01 · WOMAN",
    price: 472,
    image: "/img/safe-product-14.jpg",
    images: ["/img/safe-product-14.jpg"],
    size: alphaSizes,
    colors: ["Black"],
    material: "Silky nappa leather",
    description: "A clean-lined leather mini dress with a softened square neckline and gently shaped waist.",
    attributes: { fit: "Slim / mini", closure: "Back zip", origin: "Made in Italy" },
    tags: ["woman", "dress", "leather", "evening"],
    Features: ["Panelled construction", "Fully lined", "Hidden back zip", "Specialist clean only"],
    featured: true,
    stock: 2,
  },
  {
    id: 15,
    name: "CAMBER RELAXED JEAN — MID BLUE",
    category: "Denim Pants",
    department: "Man",
    collection: "FOUNDATIONS 01 · MAN",
    price: 306,
    image: "/img/safe-product-15.jpg",
    images: ["/img/safe-product-15.jpg"],
    size: ["28", "29", "30", "31", "32", "33", "34", "36"],
    colors: ["Mid Blue"],
    material: "100% organic cotton denim",
    description: "Relaxed straight jeans in mid blue, cut with an easy waist and a generous full-length break.",
    attributes: { fit: "Relaxed / straight", pockets: "Five pockets", origin: "Made in Italy" },
    tags: ["man", "denim", "mid blue", "relaxed"],
    Features: ["Organic rigid denim", "Relaxed seat", "Full-length inseam", "Low-impact wash"],
    featured: true,
    stock: 9,
  },
  {
    id: 16,
    name: "NORTH DOUBLE-FACE CHECK SHIRT — INK CHECK",
    category: "Tops / Jackets",
    department: "Man",
    collection: "FOUNDATIONS 01 · MAN",
    price: 288,
    image: "/img/safe-product-16.jpg",
    images: ["/img/safe-product-16.jpg"],
    size: alphaSizes,
    colors: ["Ink Check"],
    material: "Organic cotton flannel",
    description: "A relaxed double-face shirt combining ink blue, charcoal and softly brushed cotton.",
    attributes: { fit: "Oversized", closure: "Button front", origin: "Made in Italy" },
    tags: ["man", "shirt", "check", "organic cotton"],
    Features: ["Double-face construction", "Brushed organic cotton", "Chest patch pocket", "Curved hem"],
    featured: false,
    stock: 5,
  },
  {
    id: 17,
    name: "REED TAPERED JEAN — HERITAGE BLUE",
    category: "Denim Pants",
    department: "Man",
    collection: "FOUNDATIONS 01 · MAN",
    price: 258,
    image: "/img/safe-product-17.jpg",
    images: ["/img/safe-product-17.jpg"],
    size: ["28", "29", "30", "31", "32", "33", "34", "36"],
    colors: ["Heritage Blue"],
    material: "100% cotton denim",
    description: "An everyday jean with a regular rise, a softly tapered leg and a balanced vintage-blue finish.",
    attributes: { fit: "Regular / tapered", pockets: "Five pockets", origin: "Made in Italy" },
    tags: ["man", "denim", "classic", "tapered"],
    Features: ["Mid-weight denim", "Regular waist", "Tapered hem", "Antique silver hardware"],
    featured: false,
    stock: 12,
  },
  {
    id: 18,
    name: "HEARTH OVERSIZED SWEATSHIRT — UMBER",
    category: "Tops / Jackets",
    department: "Man",
    collection: "FOUNDATIONS 01 · MAN",
    price: 218,
    image: "/img/safe-product-18.jpg",
    images: ["/img/safe-product-18.jpg"],
    size: alphaSizes,
    colors: ["Umber"],
    material: "Organic cotton loopback jersey",
    description: "An oversized umber sweatshirt with dropped shoulders and a substantial dry-touch cotton surface.",
    attributes: { fit: "Oversized", neckline: "Crew", origin: "Made in Italy" },
    tags: ["man", "sweatshirt", "brown", "organic cotton"],
    Features: ["Heavyweight loopback", "Garment-dyed color", "Ribbed trims", "Dropped shoulder"],
    featured: false,
    stock: 7,
  },
  {
    id: 19,
    name: "DOCK DENIM OVERSHIRT — DEEP INDIGO",
    category: "Tops / Jackets",
    department: "Man",
    collection: "FOUNDATIONS 01 · MAN",
    price: 344,
    image: "/img/safe-product-19.jpg",
    images: ["/img/safe-product-19.jpg"],
    size: alphaSizes,
    colors: ["Deep Indigo"],
    material: "100% organic cotton denim",
    description: "An easy indigo denim overshirt with useful chest pockets and softly rounded volume.",
    attributes: { fit: "Relaxed", closure: "Metal press studs", origin: "Made in Italy" },
    tags: ["man", "denim shirt", "indigo", "layering"],
    Features: ["Two utility chest pockets", "Indigo garment wash", "Reinforced yoke", "Wear as shirt or jacket"],
    featured: true,
    stock: 6,
  },
  {
    id: 20,
    name: "DRIFT STRAIGHT SWEATPANT — UMBER",
    category: "Trousers",
    department: "Man",
    collection: "FOUNDATIONS 01 · MAN",
    price: 226,
    image: "/img/safe-product-20.jpg",
    images: ["/img/safe-product-20.jpg"],
    size: alphaSizes,
    colors: ["Umber"],
    material: "Organic cotton loopback jersey",
    description: "Relaxed umber sweatpants with an open straight hem and a clean everyday sportswear finish.",
    attributes: { fit: "Relaxed / straight", waist: "Elasticated", origin: "Made in Italy" },
    tags: ["man", "trousers", "jersey", "brown"],
    Features: ["Heavyweight loopback", "Internal drawcord", "Side seam pockets", "Open straight hem"],
    featured: false,
    stock: 8,
  },
  {
    id: 21,
    name: "FOUNDRY BOX DENIM JACKET — CHARCOAL",
    category: "Tops / Jackets",
    department: "Man",
    collection: "FOUNDATIONS 01 · MAN",
    price: 356,
    image: "/img/safe-product-21.jpg",
    images: ["/img/safe-product-21.jpg"],
    size: alphaSizes,
    colors: ["Charcoal"],
    material: "100% cotton denim",
    description: "A compact charcoal denim jacket with a boxy line, dropped shoulders and strong workwear seams.",
    attributes: { fit: "Boxy / cropped", closure: "Metal buttons", origin: "Made in Italy" },
    tags: ["man", "jacket", "denim", "vintage black"],
    Features: ["Washed black denim", "Adjustable back tabs", "Four external pockets", "Reinforced topstitching"],
    featured: true,
    stock: 4,
  },
  {
    id: 22,
    name: "RANGE WIDE JEAN — COAL WASH",
    category: "Denim Pants",
    department: "Man",
    collection: "FOUNDATIONS 01 · MAN",
    price: 272,
    image: "/img/safe-product-22.jpg",
    images: ["/img/safe-product-22.jpg"],
    size: ["28", "29", "30", "31", "32", "33", "34", "36"],
    colors: ["Coal Wash"],
    material: "100% cotton denim",
    description: "Wide-leg coal denim with a relaxed low waist and subtle fading along the seams.",
    attributes: { fit: "Low rise / wide", pockets: "Five pockets", origin: "Made in Italy" },
    tags: ["man", "denim", "wide leg", "black"],
    Features: ["Wide full-length leg", "Garment-washed black", "Relaxed waist", "Heavy tobacco stitching"],
    featured: false,
    stock: 7,
  },
  {
    id: 23,
    name: "CAMBER RELAXED JEAN — COAL WASH",
    category: "Denim Pants",
    department: "Man",
    collection: "FOUNDATIONS 01 · MAN",
    price: 298,
    image: "/img/safe-product-23.jpg",
    images: ["/img/safe-product-23.jpg"],
    size: ["28", "29", "30", "31", "32", "33", "34", "36"],
    colors: ["Coal Wash"],
    material: "100% organic cotton denim",
    description: "A relaxed straight jean in a soft charcoal wash, finished with a full-length inseam.",
    attributes: { fit: "Relaxed / straight", pockets: "Five pockets", origin: "Made in Italy" },
    tags: ["man", "denim", "straight", "black"],
    Features: ["Organic cotton denim", "Relaxed seat", "Vintage stone wash", "Full-length inseam"],
    featured: false,
    stock: 9,
  },
  {
    id: 24,
    name: "BOROUGH LOOSE JEAN — DEEP INDIGO",
    category: "Denim Pants",
    department: "Man",
    collection: "FOUNDATIONS 01 · MAN",
    price: 332,
    image: "/img/safe-product-24.jpg",
    images: ["/img/safe-product-24.jpg"],
    size: ["28", "29", "30", "31", "32", "33", "34", "36"],
    colors: ["Deep Indigo"],
    material: "80% organic cotton, 20% recycled cotton",
    description: "A fluid loose jean with a generous leg, relaxed waistband and deep indigo character.",
    attributes: { fit: "Relaxed / boyfriend", pockets: "Five pockets", origin: "Made in Italy" },
    tags: ["man", "denim", "loose fit", "deep indigo"],
    Features: ["Circular cotton blend", "Loose leg", "Relaxed waistband", "Deep indigo wash"],
    featured: true,
    stock: 5,
  },
  {
    id: 25,
    name: "FALLOW DENIM CHORE JACKET — ECRU",
    category: "Tops / Jackets",
    department: "Woman",
    collection: "FOUNDATIONS 01 · WOMAN",
    price: 338,
    image: "/img/product-25.jpg",
    images: ["/img/product-25.jpg"],
    size: alphaSizes,
    colors: ["Ecru"],
    material: "100% organic cotton denim",
    description: "A softly structured chore jacket with an easy shoulder and three useful patch pockets.",
    attributes: { fit: "Relaxed", closure: "Corozo buttons", origin: "Made in Portugal" },
    tags: ["woman", "jacket", "denim", "ecru", "organic cotton"],
    Features: ["Unbleached organic denim", "Three patch pockets", "Adjustable button cuffs", "Wash at 30°C"],
    featured: true,
    stock: 8,
  },
  {
    id: 26,
    name: "GROVE PLEATED TROUSER — DARK OLIVE",
    category: "Trousers",
    department: "Woman",
    collection: "FOUNDATIONS 01 · WOMAN",
    price: 244,
    image: "/img/product-26.jpg",
    images: ["/img/product-26.jpg"],
    size: alphaSizes,
    colors: ["Dark Olive"],
    material: "55% lyocell, 45% organic cotton",
    description: "A fluid wide-leg trouser shaped with twin front pleats and a clean tailored waistband.",
    attributes: { fit: "High rise / wide leg", pockets: "Four pockets", origin: "Made in Portugal" },
    tags: ["woman", "trousers", "olive", "lyocell", "wide leg"],
    Features: ["Soft twill weave", "Twin front pleats", "Internal waist tab", "Cool gentle wash"],
    featured: false,
    stock: 11,
  },
  {
    id: 27,
    name: "TIDE DENIM MIDI DRESS — RINSE INDIGO",
    category: "Dresses / Jumpsuit",
    department: "Woman",
    collection: "FOUNDATIONS 01 · WOMAN",
    price: 382,
    image: "/img/product-27.jpg",
    images: ["/img/product-27.jpg"],
    size: alphaSizes,
    colors: ["Rinse Indigo"],
    material: "80% organic cotton, 20% recycled cotton",
    description: "A sleeveless denim midi dress with long vertical seams and a quietly generous silhouette.",
    attributes: { fit: "Straight / relaxed", length: "Midi", origin: "Made in Portugal" },
    tags: ["woman", "dress", "denim", "indigo", "recycled cotton"],
    Features: ["Circular cotton blend", "Side-seam pockets", "Back keyhole closure", "Wash inside out"],
    featured: true,
    stock: 7,
  },
  {
    id: 28,
    name: "EMBER RIB CARDIGAN — GRAPHITE",
    category: "Knitwear",
    department: "Woman",
    collection: "FOUNDATIONS 01 · WOMAN",
    price: 192,
    image: "/img/product-28.jpg",
    images: ["/img/product-28.jpg"],
    size: alphaSizes,
    colors: ["Graphite"],
    material: "70% traceable wool, 30% recycled cashmere",
    description: "A warm rib cardigan with dropped shoulders, a soft V neckline and generous sleeves.",
    attributes: { fit: "Relaxed", closure: "Corozo buttons", origin: "Made in Italy" },
    tags: ["woman", "cardigan", "knitwear", "graphite", "recycled cashmere"],
    Features: ["Responsible wool blend", "Chunky rib structure", "Dropped shoulder", "Hand wash cold"],
    featured: false,
    stock: 5,
  },
  {
    id: 29,
    name: "QUARRY FIELD JACKET — SAND",
    category: "Tops / Jackets",
    department: "Man",
    collection: "FOUNDATIONS 01 · MAN",
    price: 412,
    image: "/img/product-29.jpg",
    images: ["/img/product-29.jpg"],
    size: alphaSizes,
    colors: ["Sand"],
    material: "65% recycled cotton, 35% organic cotton",
    description: "A balanced field jacket with four low-profile pockets and a dry, garment-washed handle.",
    attributes: { fit: "Regular / easy", closure: "Corozo buttons", origin: "Made in Portugal" },
    tags: ["man", "jacket", "sand", "utility", "recycled cotton"],
    Features: ["Recycled cotton canvas", "Four utility pockets", "Internal drawcord", "Garment washed"],
    featured: true,
    stock: 9,
  },
  {
    id: 30,
    name: "MEADOW RELAXED TROUSER — SAGE",
    category: "Trousers",
    department: "Man",
    collection: "FOUNDATIONS 01 · MAN",
    price: 236,
    image: "/img/product-30.jpg",
    images: ["/img/product-30.jpg"],
    size: ["28", "29", "30", "31", "32", "33", "34", "36"],
    colors: ["Sage"],
    material: "100% organic cotton twill",
    description: "Relaxed pleated trousers in brushed sage twill, cut with room through the seat and leg.",
    attributes: { fit: "Relaxed / straight", pockets: "Four pockets", origin: "Made in Portugal" },
    tags: ["man", "trousers", "sage", "twill", "organic cotton"],
    Features: ["Brushed organic twill", "Single front pleat", "Extended waist tab", "Wash at 30°C"],
    featured: false,
    stock: 12,
  },
  {
    id: 31,
    name: "SKYLINE MERINO CREW — SLATE BLUE",
    category: "Knitwear",
    department: "Man",
    collection: "FOUNDATIONS 01 · MAN",
    price: 274,
    image: "/img/product-31.jpg",
    images: ["/img/product-31.jpg"],
    size: alphaSizes,
    colors: ["Slate Blue"],
    material: "100% traceable merino wool",
    description: "A clean crew-neck sweater knitted in fine merino with an easy body and softly ribbed edges.",
    attributes: { fit: "Regular / relaxed", gauge: "Fine knit", origin: "Made in Italy" },
    tags: ["man", "knitwear", "merino", "blue", "responsible wool"],
    Features: ["Responsible merino wool", "Fully fashioned seams", "Ribbed trims", "Hand wash cold"],
    featured: true,
    stock: 6,
  },
  {
    id: 32,
    name: "TERRA DENIM OVERSHIRT — FADED CLAY",
    category: "Tops / Jackets",
    department: "Man",
    collection: "FOUNDATIONS 01 · MAN",
    price: 316,
    image: "/img/product-32.jpg",
    images: ["/img/product-32.jpg"],
    size: alphaSizes,
    colors: ["Faded Clay"],
    material: "100% organic cotton denim",
    description: "A clay-toned denim overshirt with a roomy cut, twin chest pockets and a lived-in wash.",
    attributes: { fit: "Oversized", closure: "Metal buttons", origin: "Made in Portugal" },
    tags: ["man", "overshirt", "denim", "clay", "organic cotton"],
    Features: ["Pigment-dyed denim", "Twin chest pockets", "Curved hem", "Color may soften with wear"],
    featured: false,
    stock: 8,
  },
];

export default productData;
